import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { updateCurrentUserProfile } from '@/api/users/usersApi';
import type {
  PlatformUser,
  UpdateCurrentUserProfileInput,
} from '@/api/users/usersApi.types';

export function useUpdateCurrentUserProfileMutation(): UseMutationResult<
  PlatformUser,
  Error,
  UpdateCurrentUserProfileInput
> {
  return useMutation({
    mutationFn: function submitProfileUpdate(changes: UpdateCurrentUserProfileInput) {
      return updateCurrentUserProfile(changes);
    },
  });
}
